import { Component, OnInit } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-parkchirpconfigs',
    templateUrl: './parkchirpconfigs.component.html',
    styleUrls: ['./parkchirpconfigs.component.scss'],
    standalone: false
})
export class ParkChirpConfigsComponent implements OnInit {
  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("URL", "Url"),
    new Datalistviewcolumn("Name", "Name"),
    new Datalistviewcolumn("Description", "Description"),
  ];

  ngOnInit(): void {}
}
